import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router'
import moment from "moment";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Button } from '@mui/material';


import PageHeader from './helper/PageHeader'
import Loading from './helper/Loading';
import { createOrUpdateWaiver, getWaiverInfo, approveWorkshop } from "./helper/APIcalls";
import { authContext } from "../context/AuthContext";
import { SuccessfulWaiveDialog } from "./helper/Dialogs";

// TBD: if a workshop is approved and you make a change to the workshop involving the class dates -> the waiver form should be reset along with workshop status

function SubHead(props) {
    return <h5 style={{ textDecorationLine: 'underline' }}>{props.children}</h5>
}

const WorkshopWaive = props => {
    const user = useContext(authContext) // used when creating waiver to set requester info (not used when viewing)
    const history = useHistory()

    const [loading, setLoading] = useState(true)
    const [showDialog, setShowDialog] = useState(false) // if the successful waiver dialog is visible
    const [editing, setEditing] = useState(true) // if the workshop is in edit mode or viewing mode (if approved is in viewing)
    // const [approving, setApproving] = useState(false)

    const [waiverInfo, setWaiverInfo] = useState({ waiverExists: false, approvedBy: null })
    const [reason, setReason] = useState('') // justification for waive
    const [approving, setApproving] = useState(false)
    const mounted = useRef(true)
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        const fetchClassInfo = async () =>  {
        const info = await getWaiverInfo(props.match.params.id, user.user)

            if (mounted.current) {
                // setExists(info.waiverExists)

                // if the user is an admin, and the waiver exists, and the waiver is not approved yet, then they can approve it
                setApproving(user.roles.isProgramCoordinator === 1 && info.waiverExists && !info.approvedBy)
                
                setWaiverInfo(info)
                setReason(info.justification) //split into its own state to simplify handling change

                if (info.approvedBy) setEditing(false) // if its not approved yet than it can still be edited

                setLoading(false)

            }

        }
        fetchClassInfo()
        // on unmount
        return () => {
            console.log("on return()")
            mounted.current = false
        }
    }, [props.match.params.id, user.roles.isProgramCoordinator, user.user])

    const handleChange = (event) => {
        if (event.target.value.length <= 255) setReason(event.target.value) //only set if less than 255 chars
    }

    const handleSubmit = async () => {
        if (submitting)
            return

        setSubmitting(true);
        await createOrUpdateWaiver(reason, props.match.params.id, user.user.username, 
            waiverInfo.workshopID, waiverInfo.dates[0].fromDate, waiverInfo.leadInstructor, waiverInfo.organization, waiverInfo.trainingProviderId)
        setSubmitting(false);
        if (mounted.current) {
            setShowDialog(true)
        }
    }

    // change this to something else?
    const handleDialogClose = () => {
        history.push('/dashboard/trainingProviders/'+user.user.username) // redirect to training provider page
    }

    const acceptWorkshop = async () => {
        const res = await approveWorkshop(props.match.params.id, waiverInfo.waiverID, user.user.username)
        console.log(res)
        history.goBack()
    }


    return (
        <>
            <PageHeader
                title={"30-Day Waiver Request"}
                cancel={history.goBack}
                actionButtons={approving ? [{ label: "Approve", action: acceptWorkshop }] : []}
            />
            {loading ?
                <Loading />
                :
                    <>
                        <SuccessfulWaiveDialog
                            open={showDialog}
                            classID={waiverInfo.workshopID}
                            classDate={moment(waiverInfo.dates[0].fromDate).format('LLL')}
                            className={waiverInfo.workshopID}
                            onClose={handleDialogClose}
                        />
                        <ValidatorForm onSubmit={handleSubmit}>
                            <SubHead>Class Information</SubHead>
                            <dl className="workshop-details">
                                <dt>Class ID:</dt>
                                <dd>{waiverInfo.workshopID}</dd>

                                <dt>{"Dates & Times:"}</dt>
                                <dd>
                                    {waiverInfo.dates.map(d =>
                                        <div key={d.ID}>
                                            {moment(d.fromDate).format('LLL') + ' - ' + moment(d.toDate).format('LT')}
                                        </div>
                                    )}
                                </dd>

                                <dt>Training Location:</dt>
                                <dd>

                                    <div>{waiverInfo.location && waiverInfo.location.NAME}</div>
                                    <div>{waiverInfo.location && waiverInfo.location.STREET}</div>
                                    <div>{waiverInfo.location && waiverInfo.location.CITY + ', ' + waiverInfo.location.STATECODE + waiverInfo.location.ZIPCODE}</div>
                                </dd>

                                <dt>Lead Instructor:</dt>
                                <dd>{waiverInfo.leadInstructor}</dd>

                                <dt>Organization:</dt>
                                <dd>{waiverInfo.organization}</dd>

                            </dl>

                            <br />

                            <SubHead>Requester Information</SubHead>
                            <dl className="workshop-details">
                                <dt>Username:</dt>
                                <dd>{waiverInfo.username}</dd>

                                <dt>Name:</dt>
                                <dd>{waiverInfo.name}</dd>

                                <dt>Email:</dt>
                                <dd>{waiverInfo.email}</dd>
                            </dl>

                            <br />

                            <SubHead>Waiver Request Information</SubHead>
                            <dl className="workshop-details">
                                <dt>Request Date:</dt>
                                <dd>{moment(waiverInfo.requestedDate).format("ddd, MMM Do YYYY, h:mm:ss a")}</dd>

                                <dt>Justification:</dt>
                                <dd>
                                    {editing && !approving ? <TextValidator
                                        label="(255 character limit)"
                                        variant="outlined"
                                        type="text"
                                        name='reason'
                                        value={reason}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        validators={['required']}
                                        errorMessages={['Justification is required']}
                                        multiline
                                        rows="5"
                                        fullWidth
                                    /> : reason}
                                </dd>

                            </dl>

                            <SubHead>Approval Information</SubHead>
                            <dl className="workshop-details">
                                <dt>Approved By:</dt>
                                <dd>{waiverInfo.approvedBy}</dd>

                                <dt>Date:</dt>
                                <dd>{waiverInfo.approvedDate ? moment(waiverInfo.approvedDate).format("ddd, MMM Do YYYY, h:mm:ss a") : ''}</dd>

                            </dl>

                            <dl className="workshop-details">
                                <dt>&nbsp;</dt>
                                <dd>
                                    {editing && !approving && <Button variant="contained" color="primary" type="submit" disabled={submitting} className={[].join(' ')} >Submit</Button>}

                                    {/* This needs to be changed from !editing to use user permissions */}
                                    {/* {approve && <Button variant="contained" color="primary" onClick={acceptWorkshop} className={[].join(' ')} >Approve</Button>} */}
                                </dd>

                            </dl>

                        </ValidatorForm>
                    </>
            }
        </>
    )
}

export default WorkshopWaive;